const whatsappEn = {
  "wa.title": "WhatsApp",
  "wa.description": "Send order updates, cash on delivery confirmations and alerts on WhatsApp from your own business number, as well as email.",
  "wa.enabled": "Send WhatsApp messages",
  "wa.not_connected": "Connect your WhatsApp Business number to message customers who give a phone number at checkout.",
  "wa.connect": "Connect WhatsApp",
  "wa.connect_title": "Connect your WhatsApp Business number",
  "wa.update": "Update details",
  "wa.paused": "WhatsApp messages are paused. Customers get emails only.",
  "wa.number": "Number",
  "wa.verified_name": "Display name",
  "wa.webhook_title": "Delivery updates",
  "wa.webhook_hint": "In your Meta app, open WhatsApp › Configuration, paste these into Webhook, and subscribe to the \"messages\" field. This shows when messages are delivered and read.",
  "wa.callback_url": "Callback URL",
  "wa.verify_token": "Verify token",
  "wa.templates": "Message templates",
  "wa.templates_hint": "WhatsApp only delivers messages a business starts using templates Meta approves. Submit ours to your account; approval usually takes minutes, sometimes up to 24 hours. Until a template is approved, that message goes by email only.",
  "wa.submit": "Submit to Meta",
  "wa.refresh": "Refresh status",
  "wa.submitted": "Templates sent to Meta for review.",
  "wa.synced": "Template status updated.",
  "wa.marketing": "Marketing",
  "wa.test": "Send a test",
  "wa.send": "Send",
  "wa.test_to": "Send to",
  "wa.test_hint": "Sends Meta's \"hello world\" sample. The number must be able to receive WhatsApp.",
  "wa.test_sent": "Test message sent.",
  "wa.disconnect": "Disconnect",
  "wa.disconnect_title": "Disconnect WhatsApp?",
  "wa.disconnect_body": "Customers will get emails only. Your number stays in your Meta account.",
  "wa.disconnected": "WhatsApp disconnected.",
  "wa.connected": "WhatsApp connected.",
  "wa.step1": "In Meta Business Suite, open WhatsApp Manager and add your business phone number (or use the one you already have).",
  "wa.step2": "At developers.facebook.com, create an app of type Business and add the WhatsApp product, linked to that WhatsApp Business account.",
  "wa.step3": "In Business settings › System users, add a system user with admin access, assign it the app and the WhatsApp account, and generate a token that never expires with whatsapp_business_messaging and whatsapp_business_management.",
  "wa.step4": "In the app's WhatsApp › API setup, copy the Phone number ID and the WhatsApp Business Account ID.",
  "wa.step5": "In the app's Settings › Basic, copy the App secret.",
  "wa.step6": "Paste them below. After connecting, set up delivery updates and submit the message templates.",
  "wa.phone_number_id": "Phone number ID",
  "wa.waba_id": "WhatsApp Business Account ID",
  "wa.access_token": "Access token",
  "wa.access_token_hint": "The system user's permanent token. Stored encrypted.",
  "wa.app_secret": "App secret",
  "wa.app_secret_hint": "Checks that delivery updates really come from Meta. Stored encrypted.",
  "wa.keep_secret": "Leave empty to keep the saved one.",
  "wa.st.approved": "Approved",
  "wa.st.pending": "In review",
  "wa.st.rejected": "Rejected",
  "wa.st.error": "Error",
  "wa.st.none": "Not submitted",
  "wa.st.paused": "Paused",
  "wa.st.disabled": "Disabled",
  "wa.type.order_confirmation": "Order confirmation",
  "wa.type.cod_confirmation": "Cash on delivery confirmation",
  "wa.type.shipping_confirmation": "Order shipped",
  "wa.type.out_for_delivery": "Out for delivery",
  "wa.type.delivered": "Delivered",
  "wa.type.ready_for_pickup": "Ready for pickup",
  "wa.type.order_cancelled": "Order cancelled",
  "wa.type.refund_notification": "Refund",
  "wa.type.back_in_stock": "Back in stock",
  "wa.type.abandoned_checkout": "Abandoned checkout reminder",
  "notif.status.read": "Read",
} as const;

export default whatsappEn;
